import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { Button, Input } from "antd";
import { ReactComponent as PlusGradient } from "../../../../../assets/svgs/plus-gradient.svg";

const { TextArea } = Input;

const AddNewDivisions = ({ onOpen, onClose }) => {
  const [subSections, setSubSections] = useState([""]); // Array of subsections
  const [errors, setErrors] = useState([]); // Array to track errors for each input

  const handleClear = () => {
    setSubSections([""]);
    setErrors([]);
    onClose();
  };

  const handleSave = () => {
    let hasError = false;
    const newErrors = subSections.map((subSection) => {
      if (!subSection.trim()) {
        hasError = true;
        return true;
      }
      return false;
    });

    setErrors(newErrors);

    if (!hasError) {
      console.log("Field Values:", subSections);
    }
  };

  const handleAddMore = () => {
    setSubSections([...subSections, ""]); // Add a new empty field
    setErrors([...errors, false]); // Add a corresponding error state
  };

  const handleInputChange = (index, value) => {
    const updatedSubSections = [...subSections];
    updatedSubSections[index] = value;
    setSubSections(updatedSubSections);
  };

  return (
    <div className="flex justify-center my-4">
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Sub Sections</h3>
          <div
            style={{
              border: "1px solid #ebedf3",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            {subSections.map((subSection, index) => (
              <div key={index} className="mb-4">
                <p className="text-base font-light px-2">
                  Division {index + 1}*
                </p>
                <Input
                  value={subSection}
                  onChange={(e) => handleInputChange(index, e.target.value)}
                  placeholder={`Enter Sub Section ${index + 1}`}
                  style={{
                    border: "1px solid #ebedf3",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                  className="text-base font-light"
                />
                {errors[index] && (
                  <p className="text-red-500 text-sm mt-2">
                    Please fill out this field.
                  </p>
                )}
              </div>
            ))}
            <div
              className="mt-5 flex items-center gap-2"
              onClick={handleAddMore}
            >
              <div
                className="w-8 h-8 rounded-lg cursor-pointer"
                style={{
                  border: "1px solid #ebedf3",
                }}
              >
                <PlusGradient className="w-8 h-8" />
              </div>
              <span className="font-light text-base text-stone-300 cursor-pointer">
                Add more
              </span>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 py-6">
            <Button
              onClick={handleClear}
              type="primary"
              style={{
                color: "#088F8F",
                background: "#e7fefe",
                border: "2px solid #088F8F",
              }}
              className="text-sm font-light w-32 py-5"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              type="primary"
              style={{ background: "#0087A3" }}
              className="text-sm font-light w-32 py-5"
            >
              Save
            </Button>
          </div>
        </div>
      </DialogBox>
    </div>
  );
};

export default AddNewDivisions;
